import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {combineLatest, Subscription} from 'rxjs';
import {AuthService} from '../../../../../auth/api/service/auth.service';
import {User} from '../../../../../account/modules/user/api/entity/user.model';
import {
    ReportAccountComponentModel
} from '../../../../report-account-component/api/entity/reportAccountComponent.model';
import {
    ReportComponentSummarySignatureFindAllService
} from '../../../../report-component/impl/service/findPaginated/reportComponentSummarySignatureFindAll.service';
import {
    ReportComponentSummaryFooterFindAllService
} from '../../../../report-component/impl/service/findPaginated/reportComponentSummaryFooterFindAll.service';
import {
    ReportComponentSummaryHeaderFindAllService
} from '../../../../report-component/impl/service/findPaginated/reportComponentSummaryHeaderFindAll.service';
import {ReportComponentModel} from '../../../../report-component/api/entity/reportComponent.model';
import {ReportComponentSummaryModel} from '../../../../report-component/api/entity/reportComponentSummary.model';
import {
    ReportComponentGetDefaultService
} from "../../../../report-component/api/service/reportComponentGetDefault.service";

@Component({
    selector: 'app-report-common-options-input-form',
    templateUrl: './report-common-options-input-form.component.html',
    providers: [
        ReportComponentSummarySignatureFindAllService,
        ReportComponentSummaryHeaderFindAllService,
        ReportComponentGetDefaultService,
        ReportComponentSummaryFooterFindAllService]
})
export class ReportCommonOptionsInputFormComponent implements OnInit, OnChanges, OnDestroy, OnChanges {

    @Input() formGroup: UntypedFormGroup;
    @Input() officeId: number;
    @Input() userId: number;

    subscriptions: Subscription[] = [];

    constructor(
        public headerService: ReportComponentSummaryHeaderFindAllService,
        public footerService: ReportComponentSummaryFooterFindAllService,
        public signatureService: ReportComponentSummarySignatureFindAllService,
        public getDefaultService: ReportComponentGetDefaultService,
        private authService: AuthService) {
    }

    ngOnInit(): void {
        this.subscriptions.push(combineLatest([
            this.authService.user,
            this.headerService.entities$,
            this.footerService.entities$,
            this.signatureService.entities$
        ]).subscribe(([user, headers, footers, signature]) => {
            this.selectElement(headers, 'headerReportComponentId', user);
            this.selectElement(footers, 'footerReportComponentId', user);
            this.selectElement(signature, 'signatureReportComponentId', user);
        }));

        this.subscriptions.push(this.authService.account.subscribe(account => {
            this.headerService.refresh();
            this.footerService.refresh();
            this.signatureService.refresh();
        }));

        if (!this.officeId && !this.userId) {
            this.reloadDefaultComponents();
        }

    }



    ngOnDestroy(): void {
        this.subscriptions.forEach(value => value.unsubscribe());
    }




    ngOnChanges(changes: SimpleChanges): void {
        if (changes['formGroup']) {
            if (this.formGroup) {
                this.formGroup.removeControl('headerReportComponentId');
                this.formGroup.removeControl('signatureReportComponentId');
                this.formGroup.removeControl('footerReportComponentId');

                this.formGroup.addControl('headerReportComponentId', new UntypedFormControl(undefined));
                this.formGroup.addControl('signatureReportComponentId', new UntypedFormControl(undefined));
                this.formGroup.addControl('footerReportComponentId', new UntypedFormControl(undefined));
            }
            if (changes['officeId'] || changes['userId']) {
                this.reloadDefaultComponents();
            }
        }
    }

    reloadDefaultComponents() {
        this.getDefaultService.executeAction({
            officeId: this.officeId,
            userId: this.userId ? this.userId : this.authService.userSnapshot?.summary?.id
        })
            .then();
    }

    selectElement(elements: ReportComponentSummaryModel[], controlName: string, user: User) {
        if (elements && elements.length > 0 && user) {
            console.log(['selectElement', user, elements]);
            let selectedElement = elements.find(value => value.user?.id === user.summary.id);
            console.log(['selectedElement', selectedElement]);
            if (!selectedElement) {
                selectedElement = elements[0];
            }
            if (selectedElement) {
                this.formGroup.get(controlName)?.setValue(selectedElement.id);
            }
        }
    }
}
